module.exports = __webpack_public_path__ + "static/media/CTLI_4-391w.36953efc.webp";